const ThumbSlide: React.FC = ({ children }) => {
    return <div className={`Slider__thumb-slide`}>{children}</div>;
};

export default ThumbSlide;
